import { Site } from '@envato/foundation-types'
import * as classnames from 'classnames'
import * as React from 'react'

import { ILocationParams } from '../../../common/reducers/reactRouterLocation'
import { getConfigBySite } from '../../../config/sites'
import SearchLink from '../../containers/searchLinkContainer'
import GridIcon from '../icons/grid'
import ListIcon from '../icons/list'

import * as styles from './index.module.css'

interface IProps {
  currentSite: Site
  locationParams: ILocationParams
  currentView: string
  hideLayoutSwitchOnMobile: boolean
}

interface IViewOption {
  value: string
  label: string
}

const LayoutSwitcher = ({
  currentSite,
  locationParams,
  currentView,
  hideLayoutSwitchOnMobile = false
}: IProps) => {
  const itemViews: IViewOption[] =
    getConfigBySite(currentSite, 'ui.item_list_views') || []

  if (itemViews.length <= 1) {
    return null
  }

  const rootClass = classnames(styles.layoutSwitcherContainer, {
    [styles.hideOnMobile]: hideLayoutSwitchOnMobile
  })

  return (
    <div className={rootClass}>
      <div className="search-facet-layout-switcher">
        <div className="btn-group">
          {itemViews.map((availableView, index) => {
            const nextQuery = {
              ...locationParams,
              view: availableView.value
            }
            const className = classnames('btn-search-switch', {
              'is-active': currentView === availableView.value
            })
            const Icon =
              availableView.value === 'grid' ? (
                <GridIcon title="Grid" />
              ) : (
                <ListIcon title="List" />
              )
            return (
              <SearchLink
                locationParams={nextQuery}
                className={className}
                key={index}
                rel={`nofollow`}
                aria-label={`${availableView.value} view`}
              >
                {Icon}
              </SearchLink>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default LayoutSwitcher
